const ChartLineData02Icon = /*#__PURE__*/ [
  ["circle", { cx: "8.5", cy: "10.5", r: "1.5", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "14.5", cy: "15.5", r: "1.5", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "18.5", cy: "7.5", r: "1.5", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M15.4341 14.2963L18 9M9.58251 11.5684L13.2038 14.2963M3 19L7.58957 11.8792", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M20 21H9C5.70017 21 4.05025 21 3.02513 19.9749C2 18.9497 2 17.2998 2 14V3", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "4" }]
];

export { ChartLineData02Icon as default };
//# sourceMappingURL=ChartLineData02Icon.js.map
